<template>
  <div>
    <a-modal
        :visible="show"
        cancelText="Anuluj"
        okText=""
        title="Nowy właściciel urządzenia"
        width="50%"
        @cancel="$emit('close')">
      <a-row :gutter="16">
        <a-col :span="24">
          <p style="font-weight: 500">Przenieś urządzenie do:</p>
          <a-input v-model="searchPhrase" placeholder="Szukaj" @change="handleInput(searchPhrase)">
            <a-icon slot="prefix" style="color:rgba(0,0,0,.25)" type="search"/>
          </a-input>
        </a-col>
        <a-col :span="24">
          <a-list item-layout="horizontal" :data-source="users">
            <a-list-item slot="renderItem" slot-scope="user">
              <a-list-item-meta>
                <h3 slot="title">{{ user.name }} {{ user.surname }} <small style="font-weight: 400; color: rgba(0, 0, 0, 0.5)">{{ user.accountUuid }}</small></h3>
                <a-row :gutter="[8, 8]" slot="description">
                  <a-col :xs="24" :sm="24" :md="24" :lg="18" :xl="20" :xxl="21">
                    <span><span style="color: rgba(0, 0, 0, 0.9)">PESEL/Numer paszportu:</span> {{ user.personId }}</span><br/>
                    <span><span style="color: rgba(0, 0, 0, 0.9)" v-if="user.homeAddress">Adres zameldowania:</span> {{ user.homeAddress }}</span><br/>
                    <span><span style="color: rgba(0, 0, 0, 0.9)" v-if="user.emailAddress">Adres e-mail:</span> {{ user.emailAddress }}</span>
                  </a-col>
                  <a-col :xs="24" :sm="24" :md="24" :lg="6" :xl="4" :xxl="3" style="text-align: right;">
                    <a-button block v-if="accountUuid !== user.accountUuid" type="primary" @click="changeOwner(user.accountUuid)">Przenieś</a-button>
                    <a-button block v-else type="primary" disabled>Aktualne</a-button>
                  </a-col>
                </a-row>
              </a-list-item-meta>
            </a-list-item>
          </a-list>
        </a-col>
      </a-row>
    </a-modal>
  </div>
</template>

<script>

import httpClient from "@/utils/httpClient";

export default {
  name: "ChangeDeviceOwnerModal",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    deviceUuid: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      searchPhrase: '',
      users: [],
      loadingUsersList: false
    }
  },
  mounted() {
    this.getUsers();
  },
  methods: {
    changeOwner(accountUuidSelected) {
      console.log(`Move device ${this.deviceUuid} to: ${accountUuidSelected}`)
      httpClient
          .put(`/admin/devices/${this.deviceUuid}/change-account/${accountUuidSelected}`)
          .then((response) => {
            this.$message.success("Urządzenie zostało przeniesione!");
            this.$emit('changedOwner', response.accountUuid);
          })
          .catch(() => {
            this.$message.error("Wystąpił błąd podczas przenoszenia urządzenia!");
          })
          .finally(() => {
            this.loadingUsersList = false;
          });
    },

    handleInput() {
      if (this.debounce) {
        clearTimeout(this.debounce);
      }
      this.debounce = setTimeout(this.getUsers, 300);
    },

    getUsers() {
      this.loadingUsersList = true;
      httpClient
          .post(`/admin/accounts?size=5&page=1`, {
            filter: this.searchPhrase,
          })
          .then((response) => {
            this.pagination = response.page;
            this.users = response.payload;
          }).finally(() => {
        this.loadingUsersList = false;
      });
    },

    goTo(obj) {
      if (this.$route.name !== obj.name) {
        this.$router.push(obj);
      }
    },
  }
}
</script>
